/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

const EventComponent = ({ event }) => {
  if (!event) return null

  const title = typeof event.title === 'string' ? event.title : event.title?.name || event.title?.title || ''
  const desc = event.desc || event.description || ''
  const roomName = event.room?.name || event.room?.title || event.roomName || ''

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: 10,
        borderRadius: 5,
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <span style={{ fontWeight: 'bold' }}>
          {title}
          <br />
          {desc}
        </span>
        <span style={{ marginTop: '10px' }}>
          {moment(event.start).format('HH:mm')}
          hrs até {moment(event.end).format('HH:mm')} hrs
        </span>
      </div>
      <span
        style={{
          marginBottom: '2px',
          fontWeight: 'bold',
        }}
      >
        {roomName}
      </span>
    </div>
  )
}

EventComponent.propTypes = {
  event: PropTypes.object.isRequired,
}

export default EventComponent
